import { Context, useContext } from 'react';

import { TripContext } from './trip.context';
import { TripContextType } from './types';

// TODO: Migrate to reservation/v2
export const useTrip = () => {
  return useContext(TripContext as Context<TripContextType>) ?? {};
};
